import React, { useState } from "react";
import ModalCard from "../../../components/ModalCard";
import {
  BGColor02,
  blackColor,
  blackShade05,
  blackShade19,
  blueColor04,
  greyColor21,
  greyColor6,
  greyColor8,
  greyColor9,
  redColor01,
  redColor05,
  whiteColor,
} from "../../../configs/styles/muiThemes";
import {
  Box,
  Button,
  CircularProgress,
  Stack,
  Typography,
  useMediaQuery,
} from "@mui/material";
import RadiosBtnWithLabel from "../../../components/Input/RadiosBtnWithLabel";
import CheckBoxWithLabel from "../../../components/Input/CheckBoxWithLabel";

const STAUS_TABS = [
  { id: 0, label: "Synced Products" },
  { id: 1, label: "New Products" },
];

const InventoryUpdateConfiramPopup = ({
  openModal,
  setOpenModal,
  branchPushLoader,
  onCloseModal,
  onSubmit,
  productCountByStatus,
  tabValue,
  selectedRowCount,
  mainBranchProducts,
  isBranch
}) => {
  const matches = useMediaQuery((theme) => theme.breakpoints.up("md"));

  const [isUpdateRequired, setIsUpdateRequired] = useState("none");
  const [pushType, setPushType] = useState("none");

  const [isPriceUpdate, setIsPriceUpdate] = useState(false);
  const [isInventoryDetails, setIsInventoryDetails] = useState(false);

  const [errorMsg, setErrorMsg] = useState("");

  const handleSubmit = () => {
    if (isUpdateRequired == "none") return;

    if (isUpdateRequired)
      if (isUpdateRequired == "Yes") {
        console.log("handleSubmit__popup");
        // if (!isPriceUpdate && !isInventoryDetails) {
        //   setErrorMsg("Select at least one option");
        //   return;
        // }
        if (pushType == "none") {
          setErrorMsg("Select at least one option");
          return;
        }
      }

    console.log("handleSubmit__popup");

    const isBoth = isPriceUpdate && isInventoryDetails;
    // const updateType = {
    //   updateType: isBoth
    //     ? "all"
    //     : isPriceUpdate
    //     ? "price"
    //     : isInventoryDetails
    //     ? "inventory"
    //     : "",
    // };
    const updateType = {
      updateType: pushType == "none" ? "" : pushType,
    };
    onSubmit(updateType);

    setErrorMsg("");
    setPushType("none");
    setIsPriceUpdate(false);
    setIsInventoryDetails(false);
    setIsUpdateRequired("none");
    onCloseModal();
  };

  return (
    <>
      <ModalCard
        open={openModal}
        handleClose={() => {
          setErrorMsg("");
          setPushType("none");
          setIsPriceUpdate(false);
          setIsInventoryDetails(false);
          setIsUpdateRequired("none");
          onCloseModal();
        }}
        width="40%"
      >
        <Box sx={{ backgroundColor: whiteColor, borderRadius: 1.8 }}>
          <Box
            sx={{
              backgroundColor: BGColor02,
              p: 1.5,
              borderRadius: "14.4px 14.4px 0 0",
              textAlign: "center",
            }}
          >
            <Typography
              variant="body1"
              fontSize={16}
              fontWeight={600}
              color={blackShade19}
              mb={0.3}
            >
              Multi Product Push
              <Typography
                variant="body1"
                fontSize={13}
                fontWeight={500}
                color={greyColor9}
              >
                <span
                  style={{
                    fontSize: "13px",
                    fontWeight: 600,
                    color: blueColor04,
                  }}
                >
                  {selectedRowCount} OF {mainBranchProducts?.length}
                </span>{" "}
                {isBranch ? 'branches' : 'products'} selected
              </Typography>
            </Typography>
          </Box>

          <Box sx={styles.modelBodyBox}>
            <Typography fontSize={13} fontWeight={500} color={blackColor}>
              Do you want to include Price and/or Inventory details in the
              catalog push?
            </Typography>

            <Box display="flex" alignItems="center">
              <RadiosBtnWithLabel
                label="Yes"
                checked={isUpdateRequired === "Yes"}
                onValuesChanged={() => {
                  setIsUpdateRequired("Yes");
                }}
                labelStyles={{
                  color: blackColor,
                  fontSize: 13,
                }}
              />

              <RadiosBtnWithLabel
                label="No"
                checked={isUpdateRequired === "No"}
                onValuesChanged={() => {
                  setErrorMsg("");
                  setPushType("none");
                  setIsPriceUpdate(false);
                  setIsInventoryDetails(false);
                  setIsUpdateRequired("No");
                }}
                labelStyles={{
                  color: blackColor,
                  fontSize: 13,
                }}
              />
            </Box>

            {isUpdateRequired == "Yes" && (
              <>
                <Box>
                  <Box display="flex" alignItems="center">
                    <RadiosBtnWithLabel
                      label="Product Price"
                      checked={pushType === "price"}
                      onValuesChanged={() => {
                        setPushType("price");
                      }}
                      labelStyles={{
                        color: blackColor,
                        fontSize: 13,
                      }}
                    />
                    <RadiosBtnWithLabel
                      label="Inventory Details"
                      checked={pushType === "inventory"}
                      onValuesChanged={() => {
                        setPushType("inventory");
                      }}
                      labelStyles={{
                        color: blackColor,
                        fontSize: 13,
                      }}
                    />
                    <RadiosBtnWithLabel
                      label="Both"
                      checked={pushType === "all"}
                      onValuesChanged={() => {
                        setPushType("all");
                      }}
                      labelStyles={{
                        color: blackColor,
                        fontSize: 13,
                      }}
                    />
                  </Box>

                  {/* <CheckBoxWithLabel
                    label="Product Price"
                    infoText=""
                    checked={isPriceUpdate}
                    onValuesChanged={() => {
                      setIsPriceUpdate(!isPriceUpdate);
                    }}
                    checkBoxStyle={styles.checkBoxStyle}
                    labelStyle={styles.labelStyle}
                  />

                  <CheckBoxWithLabel
                    label="Inventory details"
                    infoText=""
                    checked={isInventoryDetails}
                    onValuesChanged={() => {
                      setIsInventoryDetails(!isInventoryDetails);
                    }}
                    checkBoxStyle={styles.checkBoxStyle}
                    labelStyle={styles.labelStyle}
                  /> */}
                </Box>

                {errorMsg && (
                  <Typography
                    fontSize={12}
                    fontWeight={500}
                    color={redColor01}
                    mt={-0.5}
                  >
                    {errorMsg}
                  </Typography>
                )}
              </>
            )}
          </Box>

          <Box
            sx={{
              backgroundColor: BGColor02,
              p: { xs: "10px 10px 10px 10px", md: "10px 16px 16px 16px" },
              borderRadius: "0 0 14.4px 14.4px",
            }}
          >
            <Stack
              flexDirection="row"
              alignItems="center"
              justifyContent="center"
            >
              <Box display="flex" alignItems="center" gap={6}>
                <Button
                  variant="contained"
                  sx={styles.backBtn}
                  disableElevation
                  onClick={() => {
                    setErrorMsg("");
                    setPushType("none");
                    setIsPriceUpdate(false);
                    setIsInventoryDetails(false);
                    setIsUpdateRequired("none");
                    setOpenModal(false);
                  }}
                >
                  CANCEL
                </Button>

                <Button
                  variant="contained"
                  disableElevation
                  sx={styles.applyBtn}
                  onClick={() => {
                    handleSubmit();
                  }}
                  disabled={branchPushLoader || isUpdateRequired == "none"}
                  startIcon={
                    branchPushLoader && (
                      <CircularProgress size={16} sx={{ color: "inherit" }} />
                    )
                  }
                >
                  SUBMIT
                </Button>
              </Box>
            </Stack>
          </Box>
        </Box>
      </ModalCard>
    </>
  );
};

export default InventoryUpdateConfiramPopup;

const styles = {
  backBtn: {
    fontSize: 12,
    fontWeight: 500,
    backgroundColor: whiteColor,
    border: `1px solid ${redColor05}`,
    color: redColor05,
    p: "5px 20px",
    "&:hover": {
      color: redColor05,
      backgroundColor: whiteColor,
    },
  },

  applyBtn: {
    fontSize: 12,
    fontWeight: 500,
    backgroundColor: blueColor04,
    border: `1px solid ${blueColor04}`,
    color: whiteColor,
    p: "5px 20px",
    "&:hover": {
      color: blueColor04,
      backgroundColor: whiteColor,
    },
    "&.Mui-disabled": {
      border: "none",
    },
  },

  modelBodyBox: {
    // height: "60vh",
    // overflowY: "scroll",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    p: "10px 12px 0 12px",
    mb: 1,
  },

  checkbox: {
    p: 0,
    transform: "scale(1.3)",
    "&.Mui-checked": {
      color: greyColor8,
    },
  },

  iconBtn: {
    width: "40px",
    height: "32px",
    bgcolor: whiteColor,
    borderRadius: "5px",
    border: `1px solid ${greyColor9}`,
  },

  checkBoxStyle: {
    color: greyColor21,
  },

  labelStyle: {
    fontSize: { md: 13, xs: 13 },
    fontWeight: 500,
    color: blackShade05,
  },
};
